function IsTrue(value) {
  if (value == null || value.length === 0) return false;
  return value === true || value === 1;
}

/*!
 * And(value, �)
 * This is a logical function used to require more than one condition at the same time.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * SAMPLES
 * And(True, IsEqual(1, 1)) -> True
 * And(True, False) -> False
 *
 * INPUT
 * values: The expressions to check.
 *
 * OUTPUT
 * Returns True if all the expressions are True, otherwise False.
 */
function And(...values) {
  if (values == null || values.length === 0) return false;
  for (let i = 0; i < values.length; i++) {
    if (!IsTrue(values[i])) return false;
  }
  return true;
}

/*!
 * If(condition, if_true, if_false)
 *
 * Performs a logical test and returns a value for a True result, and another for a False result.
 *
 * SAMPLES
 * @id = 12309
 * If(IsGreater(@id, 10000), "Is greater", "Is not greater") -> "Is greater"
 *
 * INPUT
 * condition: The condition to be checked.
 * if_true: Output value if condition is true.
 * if_false: Output value if condition is false.
 *
 * OUTPUT
 * Returns if_true if condition is True, otherwise, returns if_false.
 */
function If(condition, ifTrue, ifFalse) {
  return IsTrue(condition) ? ifTrue : ifFalse;
}

/*!
 * Not(value)
 *
 * This is a logical function used to negate an expression.
 *
 * SAMPLES
 * Not(True) -> False
 * Not(0) -> True
 *
 * INPUT
 * value: The expression to negate.
 *
 * OUTPUT
 * Returns True if the value is False and False if the value is True.
 */
function Not(value) {
  return !IsTrue(value);
}

/*!
 * Or(value, �)
 *
 * This is a logical function used to check more than one condition at the same time.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * SAMPLES
 * Or(True, False) -> True
 * Or(False, 0) -> False
 *
 * INPUT
 * values: The expressions to check.
 *
 * OUTPUT
 * Returns True if any expression is True, otherwise False.
 */
function Or(...values) {
  if (values == null || values.length === 0) return false;
  for (let i = 0; i < values.length; i++) {
    if (IsTrue(values[i])) return true;
  }
  return false;
}

export default {
  IsTrue,
  And,
  If,
  Not,
  Or,
};
